require.register("ffss/component/row/FormationSearch", function(exports, require, module){
  $0
  
});

